<template>
    <article class="wrapper privacy">

        <h1 class="text-center">PRIVACY POLICY</h1>

        <h2 class="text-center">Voice Sail Start Timer</h2>

        <p class="text-left"><small>Last updated 2020-01-22</small></p>

        <p><span>Egor Leonenko</span> (“we” or
            “us” or “our”) respects the privacy of our users (“user” or “you”). This
            Privacy Policy explains how we collect, use, disclose, and safeguard your
            information when you visit our mobile application (the “Application”). Please
            read this Privacy Policy carefully. IF
            YOU DO NOT AGREE WITH THE TERMS OF THIS PRIVACY POLICY, PLEASE DO NOT ACCESS
            THE APPLICATION. </p>

        <p>We reserve the right to make changes to this
            Privacy Policy at any time and for any reason. We will alert you about any changes by updating the “Last
            updated” date
            of this Privacy Policy. You are encouraged to periodically review this Privacy Policy to stay informed of
            updates. You will be deemed to have been made aware of, will be subject to, and will be deemed to have
            accepted the changes in any revised Privacy Policy by
            your continued use of the Application after the date such revised Privacy Policy is posted.</p>

        <p>This Privacy Policy does not apply to the
            third-party online/mobile store from which you install the Application or make
            payments, including any in-game virtual items, which may also collect and use
            data about you. We are not responsible for any of the data collected by any such third party. </p>

        <h3>COLLECTION OF YOUR INFORMATION</h3>

        <p>We do not collect any information through the Application</p>
        <div style="height: 16px">&nbsp;</div>
    </article>
</template>

<script>
    export default {
        name: "PrivacyPage"
    }
</script>

<style lang="scss" scoped>
    .privacy {
        min-height: calc(100vh - 159px);
    }
</style>